import { http } from "@/http";

/**
 * @typedef {Object} TraducaoConsumoResponse
 * @property {string} periodo
 * @property {number} consumido_caracteres
 * @property {number | null} teto_caracteres
 * @property {number | null} percentual_do_teto
 * @property {number} projecao_caracteres
 * @property {number | null} projecao_percentual_do_teto
 * @property {number | null} custo_estimado
 * @property {number | null} custo_projetado
 * @property {number} acumulado_total_caracteres
 * @property {Object.<string, number>} por_idioma
 * @property {Object.<string, number>} por_periodo
 * @property {{ consumido_caracteres: number, limite_caracteres: number } | null} fornecedor
 */

/**
 * Consulta os dados de consumo de traduções sem alterar a resposta HTTP.
 *
 * @returns {Promise<{ data: TraducaoConsumoResponse }>}
 */
export function getTraducaoConsumo() {
  return http.get("api/traducoes/consumo");
}
